var map = {
	"./Annotation.js": 2859,
	"./Menu.js": 6577,
	"./VideoEmbed.js": 6334,
	"components/Annotation.js": 2859,
	"components/Menu.js": 6577,
	"components/VideoEmbed.js": 6334
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8965;